/**
 * Dados da empresa IPCOM
 * Centralizados para evitar duplicação e facilitar manutenção
 */

export const COMPANY = {
  // Dados principais
  name: 'IPCOM TECNOLOGIA LTDA',
  tradeName: 'IPCOM Tecnologia',
  cnpj: '06.163.889/0001-04',
  cnpjRaw: '06163889000104',

  // Endereço
  address: 'R PARAGUAI, 605, SALA 05, CENTRO, 85805-020, Cascavel/PR',
  street: 'R PARAGUAI, 605',
  complement: 'SALA 05',
  neighborhood: 'CENTRO',
  zipCode: '85805-020',
  city: 'Cascavel',
  state: 'PR',

  // Contato
  phone: '(45) 3122-5150',
  whatsapp: '(45) 99147-6495',
  email: 'adm@ipcom.com.br',
  website: 'www.ipcom.com.br',

  // Dados bancários — conta de RECEBIMENTO padrão (Sicredi, bank_accounts id 1).
  // ⚠️ Antes estava Banco do Brasil desatualizado (P1 auditoria 02/07/26).
  bank: {
    name: 'Sicredi',
    code: '748',
    agency: '0710',
    account: '51534-7',
  },
  bankInfoLine: 'Sicredi (748) Ag: 0710 C/C: 51534-7',
};

/**
 * Sócios/signatários IPCOM — FONTE ÚNICA (P1 auditoria de propostas 02/07/26).
 * Antes cada tela repetia esses dados com grafias divergentes ("Fabio Theodoro
 * Fernandes" vs "Fábio Fernandes Theodoro"). Espelho do backend:
 * src/common/company-identity.ts. Ao mudar sócio/cargo, alterar nos DOIS.
 */
export const SIGNERS = {
  fabio: {
    name: 'Fábio Fernandes Theodoro',
    email: 'adm@ipcom.com.br',
    cpf: '059.634.029-05',
    rg: '8.974.013-4',
    birthday: '1986-04-06',
    cargo: 'Sócio-Administrador',
    phone: '',
  },
  heitor: {
    name: 'Heitor Fernandes Theodoro',
    email: 'heitor@ipcom.com.br',
    cpf: '066.490.719-94',
    rg: '',
    birthday: '1988-05-10',
    cargo: 'Sócio',
    phone: '45991476495',
  },
};

/**
 * Dados formatados para uso em templates de contrato
 */
export const COMPANY_CONTRACT_VARIABLES = {
  '{{ contratada.razaoSocial }}': COMPANY.name,
  '{{ contratada.cnpj }}': COMPANY.cnpj,
  '{{ contratada.endereco }}': COMPANY.address,
};

/**
 * Dados para exibição em documentos/PDFs
 */
export const COMPANY_DISPLAY = {
  companyName: COMPANY.name,
  companyCnpj: COMPANY.cnpj,
  companyAddress: COMPANY.address,
};

export default COMPANY;
